import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { ChatWidget } from "@/components/ChatWidget";
import { COMPRACOMIGO_BASE, isCompraComigoSite } from "@/lib/site";

import Home from "@/pages/Home";
import Planos from "@/pages/Planos";
import Contato from "@/pages/Contato";
import Entrar from "@/pages/Entrar";
import RecuperarSenha from "@/pages/RecuperarSenha";
import CadastroStep1 from "@/pages/cadastro/CadastroStep1";
import { Personalidade, Habitos } from "@/pages/cadastro/Questionnaire";
import Feed from "@/pages/Feed";
import Chat from "@/pages/Chat";
import MeuPerfil from "@/pages/MeuPerfil";
import Configuracoes from "@/pages/Configuracoes";
import ListaDeEspera from "@/pages/ListaDeEspera";

// CompraComigo (/compracomigo/*, código interno "negocios"): árvore de rotas
// própria com basename, carregada sob demanda — não pesa no bundle do MoraComigo.
// Entrar/sair do /compracomigo é sempre navegação de documento (<a href>).
const NegociosApp = lazy(() => import("@/negocios/NegociosApp"));

// Se alguma navegação client-side cair em /compracomigo, recarrega o documento
// para montar a árvore do CompraComigo.
function ToCompraComigo() {
  useEffect(() => { window.location.replace(window.location.href); }, []);
  return <div className="min-h-screen bg-white" aria-busy="true" />;
}

function App() {
  if (isCompraComigoSite()) {
    return (
      <div className="App">
        <AuthProvider>
          <BrowserRouter basename={COMPRACOMIGO_BASE}>
            <Suspense fallback={<div className="min-h-screen bg-white" aria-busy="true" />}>
              <NegociosApp />
            </Suspense>
          </BrowserRouter>
        </AuthProvider>
      </div>
    );
  }
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            {/* Publicas com Header/Footer institucional (fiel ao Figma) */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/planos" element={<Planos />} />
              <Route path="/contato" element={<Contato />} />
              <Route path="/entrar" element={<Entrar />} />
              <Route path="/recuperar-senha" element={<RecuperarSenha />} />
              <Route path="/cadastro" element={<CadastroStep1 />} />
              <Route path="/cadastro/personalidade" element={<Personalidade />} />
              <Route path="/cadastro/habitos" element={<Habitos />} />
              <Route path="/listadeespera" element={<ListaDeEspera />} />
            </Route>
            <Route path={`${COMPRACOMIGO_BASE}/*`} element={<ToCompraComigo />} />

            {/* Area autenticada (header institucional dentro da propria pagina) */}
            <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
            <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
            <Route path="/perfil" element={<ProtectedRoute><MeuPerfil /></ProtectedRoute>} />
            <Route path="/configuracoes" element={<ProtectedRoute><Configuracoes /></ProtectedRoute>} />

            <Route path="*" element={<PublicLayout />} />
          </Routes>
          <ChatWidget />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
